module.exports = __webpack_public_path__ + "img/07.2d68b29c.jpg";